import React, { Component } from 'react'
import MoreButton from '../../../../components/Buttons/plus'
import LessButton from '../../../../components/Buttons/less'
import SliderResponsive from './sliderResponsive'
import { translate } from 'react-translate'

@translate('Clients')
class Clients extends Component {

  constructor (props) {
    super(props)

    this.state = {
      viewMore: false
    }
    this.handleMoreElements = this.handleMoreElements.bind(this)
  }

  handleMoreElements() {
    this.setState({viewMore: !this.state.viewMore})
  }

  render () {

    const { clients, t } = this.props

    let arrayClients = (!this.state.viewMore) ? clients.slice(0,10) : clients

    return (<div>
      <h1>{t('Client_primary_text')}</h1>
      <div className='container'>
        <div className='container-logos hidden-xs'>
          {arrayClients.map((item, index) =>
            <div className='column-client' key={index}>
              <img src={item.image} alt={item.title}/>
            </div>
          )}
        </div>
        <div className={'btn-more-container hidden-xs' + (this.state.viewMore ? ' hide-button' : '')}>
          <MoreButton onClickMore={this.handleMoreElements} />
        </div>
        <div className={'btn-less btn-more-container' + (!this.state.viewMore ? ' hide-button' : '')}>
          <LessButton onClickMore={this.handleMoreElements}/>
        </div>
       <div className='container-logos visible-xs'>
          <SliderResponsive items={clients} />
        </div>
      </div>
    </div>)
  }
}

export default Clients



// WEBPACK FOOTER //
// ./src/features/PageCompany/Components/Clients/index.js